import { useTranslation } from 'libs/translations';

export function WhatsNewSubtitle() {
  const { t } = useTranslation();

  return <h2>{t('Discover the latest features.')}</h2>;
}
